export enum CatalogSectionSortCriterionEnum {
  MANUAL = 'MANUAL',
  NAME = 'NAME',
  CODE = 'CODE',
  REFERENCE_CODE = 'REFERENCE_CODE',
  CLASSIFICATION_TYPE = 'CLASSIFICATION_TYPE',
}
